import { micromark } from 'micromark'

export interface MarkdownFile {
  filename: string
  layout: string
  title: string
  date: string
  author: string
  category: string | undefined
  excerpt: string
  content: string | undefined
}

export const parseMarkdown = (filename: string, content: string) => {
  const rawData = content.split('---\n')
  const rawMetadata = rawData[0]

  // some crap regex to get the markdown out of our files
  const layout = rawMetadata.match(/^layout: (.+)/)![1]
  const title = rawMetadata.match(/\ntitle: (.+)/)![1]
  const dateObj = new Date(
    rawMetadata
      .match(/\ndate: (.+)/)![1]
      .split('-')
      .join('/')
  ) // safari doesn't support hyphens
  const date = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(dateObj)

  const author = rawMetadata.match(/author: (.+)/)![1]

  const pageContent = rawData.slice(1).join('---\n')
  const htmlContent = micromark(pageContent, { allowDangerousHtml: true })
  const excerpt = (htmlContent.match(/<p>(.+)<\/p>/) || [])[1] || '' // prevents against empty files

  let category: string | undefined = undefined
  if (layout === 'docs') {
    category = rawMetadata.match(/category: (.+)/)![1]
  }

  const file: MarkdownFile = {
    filename,
    layout,
    title,
    date,
    author,
    category,
    excerpt,
    content: htmlContent,
  }
  return file
}
